import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@material-ui/core";
import { formTypes } from "features/Forms/formBuilder/formBuilderConsts";
import { VehicleCustomForm } from "features/vehicles/VehicleCustomForm/VehicleCustomForm";
import { useGetCustomFormResponseQuery } from "features/vehicles/VehicleCustomForm/CustomFormResponseSlice";
import { useEffect, useState } from "react";
import Authorize from "components/Authorize";
import { IconDownload, IconEdit } from "icons";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import ShimmerLoader from "components/ShimmerLoader/ShimmerLoader";

const ActivityCustomForm = ({
    onCancel,
    vehicleDetails,
    activityLog,
}) => {

    let { data: customFormResponses, error: formError, isFetching: isLoadingForms } = useGetCustomFormResponseQuery({
        vehicleId: vehicleDetails?.id,
        formType: formTypes.Activity,
        workOrderId: activityLog?.workOrderId,
        includeImages: true,
        activityItemId: activityLog?.activityItemId
    }, { skip: !activityLog?.workOrderId || !activityLog?.activityItemId });
    customFormResponses = customFormResponses || [];

    const isLoading = isLoadingForms;
    const hasResponses = customFormResponses.length > 0;

    const [mode, setMode] = useState('download');
    const [showFailuresOnly, setShowFailuresOnly] = useState(false);

    useEffect(() => {
        setMode('download');
    }, [activityLog]);

    const actions = <>
        <Button onClick={onCancel} color='primary'>
            Close
        </Button>
    </>;

    return (<>
        <Dialog open={!!activityLog} onClose={() => onCancel(false)} aria-labelledby='dialog-title' fullWidth maxWidth='lg' >
            <DialogTitle id={'dialog-title'} >
                <Grid container justifyContent="space-between">
                    <Grid item>Custom Form for {activityLog?.action}</Grid>
                    {hasResponses ? (mode == 'edit' ?
                        <Button
                            variant="outlined"
                            startIcon={<IconDownload />}
                            onClick={() => setMode('download')}
                            disabled={isLoading}>
                            View & Download Report
                        </Button> :
                        <Authorize profile={permissionProfiles.FORMS.EDIT_FORM_RESPONSE}>
                            <Button
                                variant="outlined"
                                startIcon={<IconEdit />}
                                onClick={() => setMode('edit')}
                                disabled={isLoading}>
                                Edit Form
                            </Button>
                        </Authorize>) : null}

                </Grid>
            </DialogTitle>
            <DialogContent>
                {isLoading ? <ShimmerLoader count={5} height="100" /> :
                    hasResponses ?
                        <VehicleCustomForm
                            vehicle={vehicleDetails}
                            formType={formTypes.Activity}
                            formLabel={activityLog?.action}
                            customFormResponse={customFormResponses?.[0]}
                            mode={mode}
                            isLoading={isLoading}
                            showFailuresOnly={showFailuresOnly}
                            setShowFailuresOnly={setShowFailuresOnly}
                            activity={activityLog}
                        /> :
                        <Typography variant="body1" color="textSecondary">
                            No custom form response is available for this activity. To have a response for the custom form, the activity should be completed from the mobile app.
                        </Typography>}

            </DialogContent>
            <DialogActions>
                {actions}
            </DialogActions>
        </Dialog>
    </>
    );
};

export default ActivityCustomForm;
